import { render, staticRenderFns } from "./MtgSets.vue?vue&type=template&id=feb9ad2c"
import script from "./MtgSets.vue?vue&type=script&lang=ts"
export * from "./MtgSets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports